<template>
  <div>
    <el-aside class="fullheight" :width="width" style="border-right: 1px solid #eee" v-show="asideShow">
      <eco-org-tree
        :def-id="defId"
        ref="orgTree"
        :support-filter="supportFilter"
        :default-expand-all="false"
        :show-checkbox="showCheckbox"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        @check="check"
        @setParentData="setParentData"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="show-ellipsis" :title="node.label">
            <span v-if="data.status == '0'" style="color: red">(已禁用)</span>
            {{ node.label }}
          </span>
          <el-dropdown @command="handleCommand" v-show="!showDropdown">
            <span>
              <img src="@/assets/img/iconMore.png" class="iconMore" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="data.status == 1" icon="el-icon-plus" :command="{ node: node, data, action: 'add' }">添加子组织</el-dropdown-item>
              <el-dropdown-item icon="el-icon-edit" v-if="data.parentId != 0 || data.id != 0" :command="{ node: node, data, action: 'edit' }"
                >编辑当前组织</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-delete" v-if="data.parentId != 0 || data.id != 0" :command="{ node: node, data, action: 'delete' }"
                >删除当前组织</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-lock" v-if="data.id != 0 && data.status == 1" :command="{ node: node, data, action: 'disable' }"
                >禁用当前组织</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-unlock" v-if="data.id != 0 && data.status == 0" :command="{ node: node, data, action: 'cancelDisable' }"
                >取消禁用</el-dropdown-item
              >
              <el-dropdown-item icon="el-icon-edit" v-if="data.parentId != 0 || data.id != 0" :command="{ node: node, data, action: 'update' }"
                >更新上级组织</el-dropdown-item
              >
              <el-dropdown-item icon="icon-reload" divided :command="{ node: node, data, action: 'syncTree' }">刷新</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </eco-org-tree>
    </el-aside>

    <el-dialog class="hr-script-select" width="50%" :title="title" :visible.sync="switchDialog" :close-on-click-modal="false" append-to-body destroy-on-close>
      <div slot="title" class="dialog-header-title">
        <span class="name" style="font-weight: 600">{{ title }}</span>
      </div>
      <el-form :model="switchForm" :rules="switchRules" ref="switchRuleForm" label-width="114px" class="demo-ruleForm">
        <el-form-item prop="parentId" label="上级组织:">
          <el-cascader
            v-model="switchForm.parentId"
            :options="transTreeData"
            :props="{ checkStrictly: true, label: 'name', value: 'id', emitPath: false }"
            clearable
            filterable
            style="width: 400px"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSwitch">保存</el-button>
        <el-button @click="clearableSwitchDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import styles from '@/assets/css/element-variables.scss'
import ucApi from '@/api/uc.js'

const ecoOrgTree = () => import('@/views/uc/org/HtOrgTree.vue')
export default {
  name: 'org-tree',
  components: {
    ecoOrgTree
  },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    },
    defId: {
      type: String,
      required: true
    },
    supportFilter: {
      type: Boolean,
      default: true
    },
    showDropdown: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    navbarCollapseStyle: function () {
      if (this.asideShow) {
        return { left: parseInt(this.width) + 16 + 'px' }
      }
      return { left: '0px' }
    },
    saveSysTypeUrl: function () {
      return `${window.context.portal}/sys/sysType/v1/save?parentId=${this.parentSysType.id}&isRoot=${this.parentSysType.parentId == 0 ? 1 : 0}&isPriNode=0`
    }
  },
  data() {
    return {
      treeData: {},
      transTreeData: [],
      asideShow: true,
      isExpand: true,
      showCheckbox: false,
      dialogVisible: false,
      switchDialog: false,
      title: '更新上级组织',
      switchRules: {
        parentId: [{ required: true, message: '请选择移动到的上级组织' }]
      },
      switchForm: {
        parentId: ''
      },
      sysType: {
        children: [],
        icon: '{}',
        isLeaf: 'N',
        struType: 1,
        typeKey: '',
        name: ''
      },
      parentSysType: {
        name: ''
      }
    }
  },
  methods: {
    setParentData(data) {
      this.treeData = data.data
      this.transTreeData = data.treeData
    },
    handleNodeClick(node) {
      this.$emit('node-click', node)
    },
    check(data, checkedObj) {
      this.$emit('check', data, checkedObj)
    },
    syncTree() {
      this.$refs.orgTree.loadData()
    },
    handleExpand() {
      this.isExpand = !this.isExpand
      let elTree = this.$refs.feSysTypeTree.$refs.ecoTree.$refs.elTree
      for (var i = 0; i < elTree.store._getAllNodes().length; i++) {
        elTree.store._getAllNodes()[i].expanded = this.isExpand
      }
    },
    handleCommand(command) {
      let node = command.node
      let data = command.data
      let action = command.action
      switch (action) {
        case 'add':
          // this.showDialog(data, action);
          this.$emit('addOrg', data)
          break
        case 'edit':
          // this.showDialog(data, action);
          this.$emit('editOrg', data)
          break
        case 'delete':
          this.delSysType(data)
          break
        case 'syncTree':
          this.syncTree()
          break
        case 'disable':
          this.disableSysType(data, 0)
          break
        case 'cancelDisable':
          this.disableSysType(data, 1)
          break
        case 'update':
          this.updateSysType(data)
          break
        default:
          break
      }
    },
    // 移动组织架构
    updateSysType(data) {
      this.switchForm = Object.assign({}, data)
      this.switchDialog = true
    },
    saveSwitch() {
      this.$refs.switchRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm(`是否确定更新?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            ucApi
              .updateOrg({ orgId: this.switchForm.id, parentId: this.switchForm.parentId })
              .then(
                (data) => {
                  if (data.state) {
                    this.$message.info(data.message || '组织更新成功')
                    this.$refs.orgTree.loadData()
                  }
                },
                (error) => {
                  this.$message.info(data.message || '组织更新失败')
                }
              )
              .finally(() => {
                this.clearableSwitchDialog()
              })
              .catch(() => {
                this.clearableSwitchDialog()
              })
          })
        }
      })
    },
    clearableSwitchDialog() {
      this.switchDialog = false
      this.switchForm = {}
    },
    disableSysType(data, status) {
      if (data.isParent && status == 0) {
        let sum = 0
        data.children.forEach((item) => {
          if (item.status == 1) {
            sum += 1
          }
        })
        if (sum > 0) {
          this.$message.info('此部门存在尚未禁用的下级部门，不可禁用！')
          return
        }
      }
      if (status == 1) {
        if (!data.isParent) {
          for (let i = 0; i < this.treeData.length; i++) {
            if (this.treeData[i].id == data.parentId) {
              if (this.treeData[i].status == 0) {
                this.$message.info('请先取消上级部门的禁用！')
                return
              }
            }
          }
        }
      }
      this.$confirm(`是否确定禁用[${data.name}] ?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ucApi
          .disableOrg(data.id, status)
          .then(
            (data) => {
              if (data.state) {
                this.$emit('updateStatus')
                if (status == 0) {
                  this.$message.info(data.message || '组织禁用成功')
                } else {
                  this.$message.info(data.message || '取消禁用成功')
                }

                this.$refs.orgTree.loadData()
              }
            },
            (error) => {
              if (status == 0) {
                this.$message.info(data.message || '组织禁用失败')
              } else {
                this.$message.info(data.message || '取消禁用失败')
              }
            }
          )
          .catch(() => {
            this.dialogVisible = false
          })
      })
    },
    showDialog(data, action) {
      this.dialogVisible = true
      if (data && action == 'add') {
        this.sysType.id = ''
        this.sysType.name = ''
        this.sysType.typeKey = ''
        this.parentSysType = data
        this.sysType.parentId = data.id
        this.sysType.typeGroupKey = data.parentId == 0 ? data.typeKey : data.typeGroupKey
      }
      if (data && action == 'edit') {
        this.sysType = { ...this.sysType, ...data }
      }
    },
    delSysType(data) {
      this.$confirm(`是否确定删除 [${data.name}] ?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ucApi
          .deleteOrg(data.code)
          .then(
            (data) => {
              if (data.state) {
                this.$message({
                  type: 'success',
                  message: data.message || '删除成功'
                })
                this.$refs.orgTree.loadData()
              } else {
                this.$message.error(data.message || '删除成功')
              }
            },
            (error) => {
              this.$message.error(error || '删除失败')
            }
          )
          .catch(() => {
            this.dialogVisible = false
          })
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    afterSaveData() {
      this.$refs.feSysTypeTree.loadData()
      if (this.sysType.id) {
        this.dialogVisible = false
        return
      }
      this.sysType.name = ''
      this.sysType.typeKey = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.dialogVisible = false
        })
    },
    load() {
      this.$refs.orgTree.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .navbar-collapse {
  position: absolute;
  top: 41%;
  cursor: pointer;
  width: 20px;
}

>>> .el-dropdown {
  display: none;
}

>>> .el-tree-node__content:hover .el-dropdown {
  display: inline-block;
}

>>> .navbar-collapse:hover {
  transform: scale(1.1) translateY(2px);
}

>>> .navbar-collapse:hover .navbar-collapse-arrow {
  color: #333333;
}

>>> .navbar-collapse-arrow {
  position: absolute;
  top: 38%;
  right: -3px;
  font-size: 18px;
  color: #a8a8a8;
}

>>> .navbar-collapse-bg {
  -webkit-transition: all 0.12s ease;
  height: 50px;
  border-bottom: 8px solid transparent;
  border-right: none;
  border-left: 12px solid #ebebeb;
  border-top: 8px solid transparent;
  opacity: 0.9;
}

.el-aside-footer {
  position: absolute;
  bottom: 21px;
}

>>> .custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-node i {
  visibility: hidden;
  font-weight: bold;
}

.custom-tree-node:hover i {
  visibility: visible;
}
</style>
